// Dependencies
import styled, { css } from 'styled-components'

// Utils
import { MediaQueries } from 'utils/breakpoints'

export const Container = styled.div`
  display: block;
  width: 270px;
  position: relative;

  filter: drop-shadow(0px 1px 3px rgba(16, 24, 40, 0.1))
    drop-shadow(0px 1px 2px rgba(16, 24, 40, 0.06));

  .close-icon {
    position: absolute;
    right: 24px;
    top: 4px;
  }

  > .sisu-icon {
    cursor: pointer;
    position: relative;
    left: 236px;
    top: 23px;
    font-size: 16px;
  }

  ${MediaQueries.medium} {
    margin-right: 0;
    width: 320px;

    > .sisu-icon {
      left: 282px;
    }
  }

  ${MediaQueries.notebook} {
    > .sisu-icon {
      left: 277px;
    }
  }
`

export const ChatMessageBoxContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  width: 100%;
  min-height: 400px;
  padding: 24px 20px;

  border-radius: 12px 12px 0 0;

  background-color: #f0f1f7;
`

export const ChatMessageBoxContainerMessagesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  gap: 8px;
`

type ChatMessageItemContainerStyleProps = {
  type: 'header' | 'option'
  isActive: boolean
}

export const ChatMessageItemContainer = styled.div<ChatMessageItemContainerStyleProps>`
  display: inline-block;
  padding: 20px;

  width: fit-content;
  height: auto;

  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0px 1px 3px rgba(16, 24, 40, 0.1);

  ${({ type }) =>
    type === 'header' &&
    css`
      cursor: not-allowed;
      user-select: none;
      pointer-events: none;
      position: relative;

      &::after {
        content: '';
        width: 16px;
        height: 16px;

        position: absolute;
        left: -6px;
        top: 31px;

        border-radius: 2px;
        background: rgb(255, 255, 255);

        z-index: 3;
        transform: translateY(-50%) rotate(45deg);
      }
    `}

  ${({ type, isActive }) =>
    type === 'option' &&
    css`
      cursor: pointer;

      > p {
        color: #4b9eff;
      }

      ${!!isActive &&
      css`
        border: 2px solid #4b9eff;
      `}

      ${!isActive &&
      css`
        border: 2px solid transparent;
      `}
    `}
`

export const ChatMessageItemLabel = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
`
